<template>
    <div class="vld-parent" v-if="View_acce">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>

        <div class="maintenance-tab">
            <CContainer fluid>
                <div class="row align-items-center">
                    <div class="col-12 col-lg-auto">
                        <div class="dbm_all_left">
                            <router-link :to="{ path:'/DASH/AA' }" class=" d-flex justify-content-center align-items-center">
                                {{this.getLanguage['DB']['DBMA']}}
                                <span class="annc_count ml-2">{{arry_san_length}}</span>
                                <i class="fa fa-arrow-right ml-2" aria-hidden="true"></i>
                            </router-link>
                        </div>
                    </div>
                    <div class="col">
                        <div class="dbm_all">
                            <span class="pl-0">{{this.getLanguage['DB']['MT']}}: </span>
                            <span class="dbm_title">{{ DB_Month }}</span>

                            <span>{{this.getLanguage['DB']['DG']}}: </span>
                            <span class="dbm_title">{{ DB_CDay }}</span>

                            <span>{{this.getLanguage['DB']['TD']}}: </span>
                            <span class="dbm_title">{{ DB_TDay }}</span>

                            <span>{{this.getLanguage['DB']['TE']}}: </span>
                            <span class="dbm_title">{{ DB_DProgress }} %</span>

                            <span>{{this.getLanguage['DB']['DRA']}}</span>
                            <span class="dbm_title">{{ DB_DRefresh }}</span>
                        </div>
                    </div>
                </div>
            </CContainer>
        </div>

        <!-- <div id="dashboardTab" class="w-100 mt-2">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <router-link :to="{ path:'/DASH/DBM'}" class="nav-link" :class="$route.path == '/DASH/DBM' ? 'active' : ''">
                        {{this.getLanguage['DB']['MONIT']}}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ path:'/DASH/DBO'}" class="nav-link" :class="$route.path == '/DASH/DBO' ? 'active' : ''">
                        {{this.getLanguage['DB']['OPERAT']}}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ path:'/DASH/DBP'}" class="nav-link" :class="$route.path == '/DASH/DBP' ? 'active' : ''">
                        {{this.getLanguage['DB']['PERF']}}
                    </router-link>
                </li>
            </ul>
        </div> -->

        <div class="ds-wrapper">
            <CContainer fluid>
                <CRow class="searchBar mb-1">
                    <div class='col-6 col-md-3 mb-2 mb-md-0'>
                        <customtreeselect :multiple="false"
                                          :options="dd_agentgroup"
                                          :defaultExpandLevel="Infinity"
                                          :flat="true"
                                          :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                          class="searchdashboard"
                                          @input="AgentGroupChangefs"
                                          v-model="searchAgent" />
                    </div>
                    <div class='col-6 col-md-2 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :options="dd_currency"
                                    :placeholder="this.utilGetDDLanguage('MTA.C')"
                                    class="searchdashboard"
                                    v-model="searchCurrency" />
                    </div>
                    <div class='col-6 col-md-2 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :options="dd_currency1"
                                    :placeholder="this.utilGetDDLanguage('MEM.CTCI')"
                                    class="searchdashboard"
                                    v-model="convertCurrency" />
                    </div>
                    <div class='col-12 col-md-2'>
                        <button type="button" class="btn searchBtn btn-success btn-sm btn-block" style="background: #6f6bd6;border: #6f6bd6" @click="nextGetUpdate()"><span class="searchIcon cil-search"></span><span>{{this.getLanguage['BTN']['SR']}}</span></button>
                    </div>
                </CRow>

                <div class="row">
                    <div class="col-12 col-md-2 pr-md-0 d-flex ">
                        <div class="card theme-box-container mb-1 border-radius-10 w-100">
                            <div>
                                <div class="card-body " >
                                    <div class="d-flex">
                                        <h6 class="card-title font-weight-bold mb-1" style="height: 25px;">{{this.getLanguage["DB"]["TMWB"]}}</h6>
                                        <CDropdown class="ml-2">
                                            <template #toggler>
                                                <CHeaderNavLink>
                                                    <img src="/src/assets/icons/gear-solid.svg" class="c-avatar-img " width="15" />
                                                </CHeaderNavLink>
                                            </template>

                                            <CDropdownItem href="#" @click="getDashboardTotalMember(1)">> 1.00</CDropdownItem>
                                            <CDropdownItem href="#" @click="getDashboardTotalMember(5)">> 5.00</CDropdownItem>
                                            <CDropdownItem href="#" @click="getDashboardTotalMember(20)">> 20.00</CDropdownItem>
                                            <CDropdownItem href="#" @click="getDashboardTotalMember(50)">> 50.00</CDropdownItem>
                                            <CDropdownItem href="#" @click="getDashboardTotalMember(100)">> 100.00</CDropdownItem>
                                            <CDropdownItem href="#" @click="getDashboardTotalMember(1000)">> 1000.00</CDropdownItem>
                                            <CDropdownItem href="#" @click="getDashboardTotalMember(5000)">> 5000.00</CDropdownItem>
                                        </CDropdown>
                                    </div>
                                    <h2 class="font-weight-bold m-0">{{ formatNumber(this.setTotalMember, 0) }}</h2>
                                </div>
                            </div>
                            <hr class="theme-border-green mx-3 my-0">
                            <div class="dashHover" @click="MLPage()">
                                <CCol class="displayWidget px-0">
                                    <div class="card-body">
                                        <h6 class="card-title mb-1">{{this.getLanguage["DB"]["TB"]}} ({{(this.convertCurrency==null&&this.searchCurrency==null && alreadyLoad)? this.getCurrencyCode : changeCurrency(this.dd_currency1,this.convertCurrency,this.searchCurrency) }})</h6>
                                        <h6 class="card-title font-weight-bold mb-1">
                                            {{ formatNumber(this.setTotalMemberWithBalance, 2,this.CurrencySymbolShow, false) }}
                                        </h6>
                                        <br />

                                        <div>
                                            <div class="row align-items-center mx-0 border-bottom2">
                                                <span class="my-1 col-5 px-0" style="font-size:10px"> {{this.getLanguage["MEM"]["MW"]}} </span>
                                                <span class="col-7 px-0 font-weight-bold text-right" style="font-size:10px">{{ formatNumber(this.setTotalMainWallet, 2,this.CurrencySymbolShow, false) }}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="row align-items-center mx-0">
                                                <span class="my-1 col-5 px-0" style="font-size:10px">  {{this.getLanguage["MEM"]["PW"]}} </span>
                                                <span class="col-7 px-0 font-weight-bold text-right" style="font-size:10px">{{ formatNumber(this.setTotalPromoWallet, 2,this.CurrencySymbolShow, false) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </CCol>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 pr-md-0 d-flex ">
                        <div class="card theme-box-container mb-1 border-radius-10 w-100">
                            <div>
                                <div class="card-body dashHover" @click="PDPage()">
                                    <h6 class="card-title font-weight-bold mb-1" style="height:25px;" @click.stop>{{this.getLanguage["DB"]["PD"]}}</h6>
                                    <h2 class="font-weight-bold m-0">{{ formatNumber(this.setPendingDeposit, 0) }}</h2>
                                </div>
                            </div>
                            <hr class="theme-border-green mx-3 my-0">
                            <div class="dashHover">
                                <CCol @click="changeChart('MemberDepositChart')" class="displayWidget px-0">
                                    <div class="card-body">
                                        <h6 class="card-title mb-1" style="height:25px;" @click.stop>{{this.getLanguage["DB"]["D"]}}</h6>
                                        <h5 class="font-weight-bold m-0">{{ formatNumber(this.MemberDepositTotalCount, 0) }}</h5>
                                    </div>
                                    <div class="card-footer bg-white">
                                        <template class="w-100 img-fluid">
                                            <CChartLineSimple class="px-3"
                                                              style="height:50px"
                                                              :data-points="this.MemberDepositChartData"
                                                              background-color="transparent"
                                                              border-color="success"
                                                              :label="getLanguage['DB']['MDP']"
                                                              :labels="this.MemberDepositChartLabel" />
                                        </template>
                                    </div>
                                </CCol>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 pr-md-0 d-flex">
                        <div class="card theme-box-container mb-1 border-radius-10 w-100">
                            <div>
                                <div class="card-body dashHover" @click="PWPage()">
                                    <h6 class="card-title font-weight-bold mb-1" style="height:25px;" @click.stop>{{this.getLanguage["DB"]["PW"]}}</h6>
                                    <h2 class="font-weight-bold m-0">{{ formatNumber(this.setPendingWithdraw, 0) }}</h2>
                                </div>
                            </div>
                            <hr class="theme-border-red mx-3 my-0">
                            <div class="dashHover">
                                <CCol @click="changeChart('MemberWithdrawChart')" class="displayWidget px-0">
                                    <div class="card-body">
                                        <h6 class="card-title mb-1" style="height:25px;" @click.stop>{{this.getLanguage["DB"]["W"]}}</h6>
                                        <h5 class="font-weight-bold m-0">{{ formatNumber(this.MemberWithdrawTotalCount, 0) }}</h5>
                                    </div>
                                    <div class="card-footer bg-white">
                                        <template>
                                            <CChartLineSimple class="px-3"
                                                              style="height:50px"
                                                              :data-points="this.MemberWithdrawChartData"
                                                              background-color="transparent"
                                                              border-color="danger"
                                                              :label="getLanguage['DB']['MW']"
                                                              :labels="this.MemberWithdrawChartLabel" />
                                        </template>
                                    </div>
                                </CCol>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 pr-md-0 d-flex">
                        <div class="card theme-box-container mb-1 border-radius-10 w-100">
                            <div>
                                <div class="card-body dashHover" @click="PBPage()">
                                    <h6 class="card-title font-weight-bold mb-1" style="height:25px;" @click.stop>{{this.getLanguage["DB"]["PP"]}}</h6>
                                    <h2 class="font-weight-bold m-0">{{ formatNumber(this.setPendingPromotion, 0) }}</h2>
                                </div>
                            </div>
                            <hr class="theme-border-pupple mx-3 my-0">
                            <div class="dashHover">

                                <CCol @click="changeChart('MemberBonusChart')" class="displayWidget px-0">
                                    <div class="card-body">
                                        <h6 class="card-title mb-1" style="height: 25px;" @click.stop>{{getLanguage["DB"]["TBC"]}}</h6>
                                        <h5 class="font-weight-bold m-0">{{formatNumber(this.MemberBonusTotalCount, 0)}}</h5>
                                    </div>
                                    <div class="card-footer bg-white">
                                        <template>
                                            <CChartLineSimple class="px-3"
                                                              style="height:50px"
                                                              :data-points="this.MemberBonusChartData"
                                                              background-color="transparent"
                                                              border-color="#7800b6"
                                                              :label="getLanguage['DB']['MBNS']"
                                                              :labels="this.MemberBonusChartLabel" />
                                        </template>
                                    </div>
                                </CCol>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="row">
                            <div class="col-6 pr-md-0">
                                <div class="card theme-box-container border-yellow mb-1 border-radius-10">
                                    <div>
                                        <div class="card-body dashHover" @click="MemberOnline()">
                                            <h6 class="card-title font-weight-bold mb-1" style="height:25px;" @click.stop>{{this.getLanguage["DB"]["MO"]}}</h6>
                                            <h2 class="font-weight-bold m-0">{{ formatNumber(this.setMemberOnline, 0) }}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="card theme-box-container border-red mb-1 border-radius-10">
                                    <div>
                                        <div class="card-body dashHover" @click="CSOnline()">
                                            <h6 class="card-title font-weight-bold mb-1" style="height:25px;" @click.stop>{{this.getLanguage["DB"]["CSO"]}}</h6>
                                            <h2 class="font-weight-bold m-0">{{ formatNumber(this.setCSOnline, 0) }}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="card theme-box-container mb-1 border-radius-10">
                                    <div>
                                        <CCol @click="changeChart('NewRegisterChart')" class="displayWidget px-0 dashHover">

                                            <div class="card-body">
                                                <h6 class="card-title font-weight-bold mb-1" style="height:25px;" @click.stop>{{this.getLanguage["DB"]["R"]}}</h6>
                                                <h2 class="font-weight-bold m-0">{{ formatNumber(this.MemberRegisterTotalCount, 0) }}</h2>
                                            </div>
                                            <div class="card-footer bg-white border-radius-10">
                                                <template>
                                                    <CChartLineSimple class="px-3"
                                                                      style="height:50px"
                                                                      :data-points="this.MemberRegisterChartData"
                                                                      background-color="transparent"
                                                                      border-color="warning"
                                                                      :label="getLanguage['DB']['MRG']"
                                                                      :labels="this.MemberRegisterChartLabel" />
                                                </template>
                                            </div>
                                        </CCol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CCard class="mb-1">
                    <CCardBody>
                        <CRow>
                            <CCol sm="8">
                                <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["SMB"]["M"]}}</h4>
                            </CCol>

                            <CCol sm="4" class="d-none d-md-block text-right">
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   :locale-data="{ format: 'DD MMM yyyy HH:mm' }"
                                                   @update="SelectDate"
                                                   v-model="selectedDateTS"
                                                   :ranges="getDateRange()">
                                </date-range-picker>
                            </CCol>
                        </CRow>

                        <MemberChart style="height: 250px; margin-top: 10PX; margin-bottom: 10PX;" />

                        <div class="tempScrollbar p-0">
                            <button :class="bool_isShowDeposit ? 'btn btn-sm btn-outline-deposit mr-2 active' : 'btn btn-sm btn-outline-deposit mr-2'" @click="bool_isShowDeposit ? bool_isShowDeposit = false : bool_isShowDeposit = true">
                                {{this.getLanguage["SMB"]["M"]}} {{this.getLanguage["SMB"]["D"]}} <i class="fa fa-eye" v-if="bool_isShowDeposit"></i>
                            </button>
                            <button :class="bool_isShowWithdraw ? 'btn btn-sm btn-outline-withdraw mr-2 active' : 'btn btn-sm btn-outline-withdraw mr-2'" @click="bool_isShowWithdraw ? bool_isShowWithdraw = false : bool_isShowWithdraw = true">
                                {{this.getLanguage["SMB"]["M"]}} {{this.getLanguage["SMB"]["W"]}} <i class="fa fa-eye" v-if="bool_isShowWithdraw"></i>
                            </button>
                            <button :class="bool_isShowBonus ? 'btn btn-sm btn-outline-bonus mr-2 active' : 'btn btn-sm btn-outline-bonus mr-2'" @click="bool_isShowBonus ? bool_isShowBonus = false : bool_isShowBonus = true">
                                {{this.getLanguage["SMB"]["M"]}} {{this.getLanguage["DB"]["BONUS"]}} <i class="fa fa-eye" v-if="bool_isShowBonus"></i>
                            </button>
                            <!-- Hui Lee temp hide -->
                            <!-- <button :class="bool_isShowOnline ? 'btn btn-sm btn-outline-online mr-2 active' : 'btn btn-sm btn-outline-online mr-2'" @click="bool_isShowOnline ? bool_isShowOnline = false : bool_isShowOnline = true">
                                {{this.getLanguage["SMB"]["M"]}} {{this.getLanguage["MEM"]["OLN"]}} <i class="fa fa-eye" v-if="bool_isShowOnline"></i>
                            </button> -->
                            <button :class="bool_isShowRegister ? 'btn btn-sm btn-outline-register mr-2 active' : 'btn btn-sm btn-outline-register mr-2'" @click="bool_isShowRegister ? bool_isShowRegister = false : bool_isShowRegister = true">
                                {{this.getLanguage["GAME"]["NEW"]}} {{this.getLanguage["MEM"]["RTS"]}} <i class="fa fa-eye" v-if="bool_isShowRegister"></i>
                            </button>
                        </div>
                        <!-- Hui Lee temp hide -->
                        <!-- <div class="tempScrollbar">
                            <a href="#" class="col-auto btn btn-primary mr-2" v-for="(item, index) in ['GD88 CASINO', 'N2 CASINO', 'NETENT SLOTS', 'BTG SLOTS','KA FISHING', 'POKER V', 'PRAGMATICPLAY SLOTS', 'PRAGMATICPLAY CASINO','REDTIGER SLOTS', 'SA GAMING CASINO', 'SIMPLEPLAY SLOTS', 'YGGDRASIL SLOTS']" :key="index">
                                {{item }} - {{randomNumber()}}
                            </a>
                        </div> -->
                    </CCardBody>
                </CCard>

                <div class="row">
                    <div class="col-12 col-md-9 pr-md-0">
                        <div class="card theme-box-collapseContainer mb-1 border-radius-10 w-100 h-100 border-radius-10">
                            <div class="card-body border-radius-10 p-0" style="display:flex;flex-direction:column">
                                <div class="card-header border-radius-10 py-3" style=" border-bottom-left-radius: 0px !important; border-bottom-right-radius: 0px !important;">
                                    <strong>{{this.getLanguage["DB"]["ARP"]}}</strong>
                                    <small class="icon-notification rounded-pill ml-2">{{arry_rpl.length}}</small>
                                </div>
                                <div class="card-body py-2 px-1">
                                    <div class="text-center" v-if="arry_rpl.length==0"> {{getLanguage["GL"]["NR"]}}</div>
                                    <div class="hideMore">
                                        <div class="col-12">
                                            <div class="row">

                                                <div v-for="(data,index) in arry_rpl" class="col-6 col-md-3 paddingpromotion mt-2" :key="index+data.PC" v-if="index < 4">
                                                    <div class="card theme-box-container dashHover" :style="changeBackgroudColor(data.P,data.BB)">
                                                        <div @click="DailyPromoPage(data.PC,data.PFTS,data.PTTS,data.TT)">
                                                            <div class="card-body cardpromotion">
                                                                <h6 class="card-title font-weight-bold mb-1 dashActivePromo" @click.stop>{{data.PC}}</h6>
                                                                <div class="promo-progress-bar">
                                                                    <vue-circle :progress="data.P"
                                                                                :size="60"
                                                                                line-cap="round"
                                                                                :fill="RenderProgressColor(data.P)"
                                                                                empty-fill="rgba(0, 0, 0, .1)"
                                                                                :animation-start-value="0.0"
                                                                                :start-angle="0"
                                                                                insert-mode="append"
                                                                                :show-percent="showpercent(data.BB)"
                                                                                :thickness="5">
                                                                        <span v-if="data.BB==0" style="font-size:60px">&infin;</span>

                                                                    </vue-circle>

                                                                </div>

                                                                <div class="card-footer m-n20">
                                                                    <h6 v-if="data.TT!=4" class=" mb-1" @click.stop>{{getLanguage["DB"]["TBC"]}}</h6>
                                                                    <h6 v-else class=" mb-1" @click.stop>{{getLanguage["DB"]["TFS"]}}</h6>
                                                                    <h6 v-if="data.TT!=4" class="font-weight-bold mb-0" :style="changeColor(data.BC,data.BB)" @click.stop>{{formatNumber(data.BC, 2, data.CS)}}</h6>
                                                                    <h6 v-else class="font-weight-bold mb-0" :style="changeColor(data.BC,data.BB)" @click.stop>{{formatNumber(data.BC, 2, data.CS) }}</h6>
                                                                    <h6 v-if="data.TT!=4" class="font-weight-bold mb-0" @click.stop>{{formatNumber(data.BB, 2, data.CS)}}</h6>
                                                                    <h6 v-else class="font-weight-bold mb-0" @click.stop>-</h6>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button v-if="arry_rpl.length!=0" class="btn btn-block font-weight-bold dashHover buttonpromotion" @click="showMoreDetails(1)">{{getLanguage["DB"]["SM"]}} <i class="fa-fw fas fa-angle-down"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3">
                        <div class="row">
                            <div class="col-12 pt-2 pt-md-0">
                                <div class="card theme-box-container m-0 border-radius-10 w-100 h-100">
                                    <div class="card-body ">
                                        <h6 class="card-title font-weight-bold mb-1">{{getLanguage["DB"]["GUM"]}}</h6>
                                        <div class="hideMore1">
                                            <ul v-if="arry_SA.length==0" class="list-status mb-0">
                                                <li>
                                                    {{getLanguage["GL"]["NR"]}}
                                                </li>
                                            </ul>
                                            <ul v-for="(data,index) in arry_SA" class="list-status mb-0">
                                                <li class="list-status-off dashHover" @click="SAPage(data.ACT)">
                                                    <span class="font-weight-bold">{{substrContent(data.ACT, 15)}}</span>
                                                    <br /><span>{{substrContent(data.AC, 15)}}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div v-if="arry_SA.length!=0" class="col-12 text-center">
                                            <button class="col-8 btn btn-sm btn-navy rounded-pill dashHover" @click="showMoreDetails(2)">{{getLanguage["DB"]["MORE"]}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 pt-2">
                                <div class="card theme-box-container m-0 border-radius-10 w-100 h-100">
                                    <div class="card-body ">
                                        <h6 class="card-title font-weight-bold  mb-1" @click.stop>{{getLanguage["DB"]["BL"]}}</h6>
                                        <div class="hideMore1">
                                            <ul v-if="arry_bl.length==0" class="list-status mb-0">
                                                <li>
                                                    {{getLanguage["GL"]["NR"]}}
                                                </li>
                                            </ul>
                                            <ul class="list-status mb-0" v-for="(data,index) in arry_bl">
                                                <li class="list-status-off" @click.stop>
                                                    {{data.BN}} - {{data.BA}}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-12 text-center">
                                            <button class="col-8 btn btn-sm btn-navy rounded-pill" @click="showMoreDetails(3)">{{getLanguage["DB"]["MORE"]}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CContainer>
        </div>

        <div v-if="bool_isAMVD">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["DD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="close(1)">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}} :</label>
                                        <CInput size="sm"
                                                disabled
                                                :value="obj_ad.U" @change="v => obj_ad.U = v" />
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TID"]}} :</label>
                                        <CInput size="sm" :value="obj_ad.TID" @change="v => obj_ad.TID = v" />
                                    </CCol>
                                    <CCol col="6" v-if="obj_ad['RURL'] != null && obj_ad['RURL']!=''">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RURL"]}} :</label>
                                        <div style="display:block;">
                                            <label class="col-form-label-sm">
                                                <span>
                                                    <a :href="getImgUrl(obj_ad['RURL'])" target="_blank" style="color:blue">
                                                        <u>{{this.getLanguage["MTA"]["RURL"]}}</u>
                                                    </a>
                                                </span>
                                            </label>
                                        </div>
                                    </CCol>
                                </CRow>

                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["BKN"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bank"
                                                    v-model="obj_ad['BNI']"
                                                    @input="BankNameChange($event,1)"
                                                    :clearable="false"
                                                    disabled />
                                        <span class="ErrMsg">{{ ValidationErrMsg('BNI','BKN',1) }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["BAN"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bankacc"
                                                    v-model="obj_ad['BAI']"
                                                    :clearable="false"
                                                    disabled />
                                        <span class="ErrMsg">{{ ValidationErrMsg('BAI','BAN',1) }}</span>
                                    </CCol>
                                </CRow>

                                <!--<CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MB"]}} :</label>
                                        <CInput size="sm" :value="obj_ad.MB" @change="v => obj_ad.MB = v" />
                                    </CCol>

                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MAN"]}} :</label>
                                        <CInput size="sm" :value="obj_ad.MBA" @change="v => obj_ad.MBA = v" />
                                    </CCol>
                                </CRow>-->


                                <CRow>
                                    <!--<CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MANO"]}} :</label>
                                        <CInput size="sm" :value="obj_ad.MBN" @change="v => obj_ad.MBN = v" />
                                    </CCol>-->
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MB"]}} :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_membankname"
                                                    :clearable="false"
                                                    v-model="mamBankAcc"
                                                    openDirection="below" />

                                    </CCol>

                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TA"]}}* : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                        <CInput disabled
                                                :prepend="obj_ad['CS']"
                                                size="sm"
                                                :value="ThousandSeparator(obj_ad.TA, getThousandCurrency ? 3 : 2)"
                                                @change="v => obj_ad.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('TA','TA',1) }}</span>
                                    </CCol>
                                </CRow>

                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                        <CTextarea rows="7" size="sm" v-model="obj_ad['R']" />
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-success" size="sm" @click="approveTransaction(1)">
                                        {{this.getLanguage['GL']['APR']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>

                </div>
            </transition>
        </div>

        <div v-if="bool_isAMVW">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["WD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="close(2)">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}} :</label>
                                            <CInput size="sm"
                                                    disabled
                                                    :value="obj_aw.U" @change="v => obj_ad.U = v" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MB"]}}* :</label>
                                            <CInput size="sm" :value="obj_aw.MB" @change="v => obj_ad.MB = v" disabled />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MB','MB',2) }}</span>
                                        </CCol>

                                        <CCol col="5">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MAN"]}}* :</label>
                                            <CInput v-if="!getUserInfo.IHMI" size="sm" :value="obj_aw.MBA" @change="v => obj_ad.MBA = v" disabled />
                                            <CInput v-else size="sm" :value="HideInfo(getUserInfo.IHMI, obj_aw.MBA, 4)" disabled />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MBA','MAN',2) }}</span>
                                        </CCol>
                                    </CRow>


                                    <CRow>
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MANO"]}}* :</label>
                                            <CInput v-if="!getUserInfo.IHMI" size="sm" :value="obj_aw.MBN" @change="v => obj_ad.MBN = v" disabled />
                                            <CInput v-else size="sm" :value="HideInfo(getUserInfo.IHMI, obj_aw.MBN, 4)" disabled />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MBN','MANO',2) }}</span>
                                        </CCol>

                                        <CCol col="5">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TA"]}}* : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput disabled
                                                    :prepend="obj_aw['CS']"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_aw.TA, getThousandCurrency ? 3 : 2)"
                                                    @change="v => obj_aw.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TA','TA',2) }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage['MTA']['CAD']}}* :</label> <CButton size="sm" color="outline-info" style="float: right;" @click="addBank()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>
                                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                <span class="RAMsg">{{this.getLanguage["MTA"]["RA"]}} : {{ CalculateRemainAmount( obj_aw.TA, obj_aw.CS ) }}</span>
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width:0%">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width:0%">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th style="width:35%">{{this.getLanguage['MTA']['BKN']}}</th>
                                                            <th style="width:40%">{{this.getLanguage['MTA']['BAN']}}</th>
                                                            <th style="width:25%" class="tableCtnRight">{{this.getLanguage['MTA']['TA']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_aw.BankList == 0 || !obj_aw.BankList">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_aw.BankList">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removeBank(index)'></i> <!--here Remove -->
                                                                <i class="cil-color-border" @click='editBank(data,index)'></i> <!--here Edit -->
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{data.BN}}</td>
                                                        <td>{{data.BA}}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.TA, '.', ',', 2, obj_aw.CS) }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                            <span class="ErrMsg">{{ ErrBAAmount }}</span>
                                        </CCol>
                                        <CCol col="5">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                            <CTextarea rows="7" size="sm" v-model="obj_aw['R']" />
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-success" size="sm" @click="approveTransaction(2)">
                                        {{this.getLanguage['GL']['APR']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>

                </div>
            </transition>
        </div>

        <div v-if="bool_isRMVD">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["RD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeReject(1)">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}} :</label>
                                        <CInput size="sm"
                                                disabled
                                                v-model="obj_ad['U']" />
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RR"]}} :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreason"
                                                    :placeholder="getLanguage['MTA']['RR']"
                                                    v-model="obj_Reject.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Reject.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['RR']" size="sm" v-model="obj_Reject.reason2" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationErrMsg('RR','RR',1) }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                        <CTextarea rows="7" size="sm" v-model="obj_ad['R']" />
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-danger" size="sm" @click="rejectTransaction(1)">
                                        {{this.getLanguage['GL']['REJ']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isRMVW">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["RD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeReject(2)">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}} :</label>
                                        <CInput size="sm"
                                                disabled
                                                v-model="obj_aw['U']" />
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RR"]}} :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreason"
                                                    :placeholder="getLanguage['MTA']['RR']"
                                                    v-model="obj_Reject.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Reject.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['RR']" size="sm" v-model="obj_Reject.reason2" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationErrMsg('RR','RR',2) }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                        <CTextarea rows="7" size="sm" v-model="obj_aw['R']" />
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-danger" size="sm" @click="rejectTransaction(2)">
                                        {{this.getLanguage['GL']['REJ']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isRMVP">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <CRow style="width:80%;max-width:500px;"
                          role="dialog"
                          aria-labelledby="modalTitle"
                          aria-describedby="modalDescription">
                        <CCard style="height:100%;">
                            <CCardBody class="modal-body reject-reason-modal" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["PM"]["RR"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeReject(3)">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" style="overflow:inherit;">
                                    <CRow>
                                        <CCol col="12">
                                            <treeselect :multiple="false"
                                                        :options="dd_rejectreason"
                                                        :placeholder="getLanguage['PM']['RR']"
                                                        v-model="obj_Reject.reason"
                                                        :max-height="70"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`" />
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="obj_Reject.reason==999">
                                        <CCol col="12">
                                            <CInput class="margint10" :placeholder="getLanguage['PM']['RR']" size="sm" v-model="obj_Reject.reason2" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <span class="ErrMsg">{{ ValidationErrMsg('RR','RR',3) }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                            <CTextarea rows="7" size="sm" v-model="obj_Reject['R']" />
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-danger" size="sm" @click="rejectTransaction(3)">
                                        {{this.getLanguage['GL']['REJ']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </CRow>
                </div>
            </transition>
        </div>

        <div v-if="bool_isABA">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:50%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["MTA"]["CAD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddBank()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["BKN"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bank"
                                                    v-model="obj_bank['BNI']"
                                                    @input="BankNameChange($event,2,false)"
                                                    :clearable="false" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BNI','BKN') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["BAN"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bankacc"
                                                    v-model="obj_bank['BAI']"
                                                    :clearable="false" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BAI','BAN') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TA"]}}* : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                        <span class="RAMsg">{{this.getLanguage["MTA"]["RA"]}} : {{ CalculateRemainAmount( obj_aw.TA, obj_aw.CS ) }}</span>
                                        <CInput :prepend="obj_aw['CS']"
                                                size="sm"
                                                :value="ThousandSeparator(obj_bank.TA, getThousandCurrency ? 3 : 2)" @change="v => obj_bank.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('TA','TA') }}</span>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBank()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_showDetails">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['GL']['D']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showDetails = !bool_showDetails">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <div class='searchCol'>
                                            <span class='searchLabel' v-if="checkDetails==1">{{this.getLanguage['GL']['PDGMT']}}</span>
                                            <span class='searchLabel' v-else>{{this.getLanguage['GL']['LDDGMT']}}</span>
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    disabled />
                                        </div>
                                        <div class='searchCol'>
                                            <span class='searchLabel'>{{this.getLanguage['GL']['WDGMT']}}</span><br />
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    disabled />
                                        </div>
                                    </CRow>
                                    <div style="height:400px">
                                        <div class='table-wrapper'>
                                            <header class="table-header" style="top: -20px">
                                                <strong>{{this.getLanguage['MEM']['CKMT']}}</strong>
                                                <div class="pageBtn" v-if="bool_showAllTransaction">
                                                    <button @click="prevPage()">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page"
                                                           type="number"
                                                           @keyup="int_Page = int_Page" />
                                                    <span class="tableItemCount">/ {{int_TP}}</span>
                                                    <button @click="nextPage()">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                            </header>
                                            <table class='custom-table afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th style="top:30px">
                                                            {{this.getLanguage['MEM']['CKMPVD']}}
                                                        </th>
                                                        <th class="tableCtnRight" style="top:30px">
                                                            {{this.getLanguage['MEM']['CKMWL']}}
                                                        </th>
                                                        <th class="tableCtnRight" style="top:30px">
                                                            {{this.getLanguage['MEM']['TO']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_TransactionList.length == 0">
                                                        <td colspan="10">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_TransactionList">
                                                        <td>
                                                            <router-link :to="{ path:'/R/WINLV2', query:{ gpi: data.GPI, as: 't', i: obj_member.I, u: obj_member.U, df: searchCreatedTS.startDate,dt:searchCreatedTS.endDate }}" target="_blank">
                                                                <b>{{utilGetErrorLanguage('GP.' + data.PN)}}</b>
                                                            </router-link>
                                                        </td>
                                                        <td :class="data.WLA >= 0? 'positive-number tableCtnRight': 'negative-number tableCtnRight'">{{ formatNumber(data.WLA, 2, data.CS) }}</td>
                                                        <td :class="data.TA >= 0? 'positive-number tableCtnRight': 'negative-number tableCtnRight'">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--runningPromo-->
        <div v-if="showPromoDetails">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowCD">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["DB"]["ARP"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="showPromoDetails = !showPromoDetails">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content p-0">
                                    <div class="card-body p-0 py-2">
                                        <div v-if="arry_rpl.length==0"> {{getLanguage["GL"]["NR"]}}</div>

                                        <div class="row">
                                            <div v-for="(data,index) in arry_rpl" class="col-md-3">
                                                <div class="card theme-box-container mb-3 border-radius-10 dashHover" :style="changeBackgroudColor(data.P,data.BB)">
                                                    <div @click="DailyPromoPage(data.PC,data.PFTS,data.PTTS,data.TT)">
                                                        <div class="card-body cardpromotioninside">
                                                            <h6 class="card-title font-weight-bold mb-1 dashActivePromo" @click.stop>{{data.PC}}</h6>
                                                            <div class="promo-progress-bar">
                                                                <vue-circle :progress="data.P"
                                                                            :size="80"
                                                                            line-cap="round"
                                                                            :fill="RenderProgressColor(data.P)"
                                                                            empty-fill="rgba(0, 0, 0, .1)"
                                                                            :animation-start-value="0.0"
                                                                            :start-angle="0"
                                                                            insert-mode="append"
                                                                            :show-percent="showpercent(data.BB)"
                                                                            :thickness="5">
                                                                    <span v-if="data.BB==0" style="font-size:80px">&infin;</span>

                                                                </vue-circle>

                                                            </div>
                                                            <div class="card-footer m-n20">
                                                                <h6 v-if="data.TT!=4" class=" mb-1" @click.stop>{{getLanguage["DB"]["TBC"]}}</h6>
                                                                <h6 v-else class=" mb-1" @click.stop>{{getLanguage["DB"]["TFS"]}}</h6>
                                                                <h5 v-if="data.TT!=4" class="font-weight-bold mb-0" :style="changeColor(data.BC,data.BB)" @click.stop>{{formatNumber(data.BC, 2, data.CS)}}</h5>
                                                                <h5 v-else class="font-weight-bold mb-0" :style="changeColor(data.BC,data.BB)" @click.stop>{{formatNumber(data.BC, 2, data.CS) }}</h5>
                                                                <h5 v-if="data.TT!=4" class="font-weight-bold mb-0" @click.stop>{{formatNumber(data.BB, 2, data.CS)}}</h5>
                                                                <h5 v-else class="font-weight-bold mb-0" @click.stop>-</h5>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="showGameMaintenance">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["DB"]["GUM"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="showGameMaintenance = !showGameMaintenance">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>

                                <table class='custom-table custom-table-inPopUp afb-blue'>
                                    <thead>
                                        <tr>
                                            <th rowspan="2" style="width:60px">{{this.getLanguage["GL"]["NO"]}}</th>
                                            <th rowspan="2">{{this.getLanguage["AN"]["AT"]}}</th>
                                            <th colspan="2" id="nestedTable" style="width:200px">{{this.getLanguage["AN"]["S"]}}</th>
                                            <th rowspan="2" style="width:100px">{{this.getLanguage["GL"]["UTS"]}}</th>
                                        </tr>
                                        <tr>
                                            <th style="width:100px; top: 1px">{{this.getLanguage["AN"]["FR"]}}</th>
                                            <th style="top: 1px">{{this.getLanguage["AN"]["TO"]}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <td colspan="100%" v-if=" arry_SA.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                    <tr v-for="(data,index) in arry_SA" :class="renderStatus(data.status)">
                                        <td>{{ CountItem(index+1) }}</td>
                                        <td class='kema-eft' @click="SAPage(data.ACT)">
                                            {{ substrContent(data.ACT, 80) }}
                                            <br>
                                            <p class="kema-eft annC">"{{ substrContent(data.AC, 180) }}"</p>
                                        </td>
                                        <td v-if="data.HS == false">{{getLanguage["AN"]["IN"]}}</td>
                                        <td v-else>{{ formatDateTime(data.STS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                        <td v-if="data.HS == false">{{getLanguage["AN"]["IN"]}}</td>
                                        <td v-else>{{ formatDateTime(data.ETS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                        <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                    </tr>
                                    </tbody>
                                </table>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="showBankAccount">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="showBankAccount = !showBankAccount">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>

                                <table class='custom-table custom-table-inPopUp afb-blue'>
                                    <thead>
                                        <tr>
                                            <th style="top:0px;width:60px">
                                                {{this.getLanguage["GL"]["NO"]}}
                                            </th>
                                            <th style="top:0px">
                                                {{this.getLanguage["BANK"]["BN"]}}
                                            </th>
                                            <th style="top:0px">
                                                {{this.getLanguage["MEM"]["BA"]}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="arry_bl.length == 0">
                                            <td colspan="10">{{this.getLanguage['GL']['NR']}}</td>
                                        </tr>
                                        <tr v-for="(data,index) in arry_bl">
                                            <td>{{ CountItem(index+1)}}</td>
                                            <td>{{ data.BN}}</td>
                                            <td>{{ data.BA}}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closePreview">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!-- member promotion transaction table -->
        <div class="container-fluid" v-if="View_acce2">
            <div class='dashBoardPaddingTop'>
                <div class='table-wrapper' style="margin: 0;">
                    <header class="table-header p-0">
                        <button type="button" class="btn p-0" @click="MemberOperationPage()">
                            <div id="dashboardmonitoring"></div>
                            <strong><i class="fa-solid fa-shuffle"></i> {{this.getLanguage['DB']['RMOL']}}</strong>
                        </button>
                    </header>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MemberChart from './Chart/MemberChart'
    import MemberRegisterChart from './Chart/MemberRegisterChart'
    import NewRegisterChartMonth from './Chart/NewRegisterChartMonth'
    import NewRegisterChartYear from './Chart/NewRegisterChartYear'
    import MemberOnlineChart from './Chart/MemberOnlineChart'
    import MemberOnlineChartMonth from './Chart/MemberOnlineChartMonth'
    import MemberOnlineChartYear from './Chart/MemberOnlineChartYear'
    import MemberDepositChart from './Chart/MemberDepositChart'
    import MemberDepositChartMonth from './Chart/MemberDepositChartMonth'
    import MemberDepositChartYear from './Chart/MemberDepositChartYear'
    import MemberWithdrawChart from './Chart/MemberWithdrawChart'
    import MemberWithdrawChartMonth from './Chart/MemberWithdrawChartMonth'
    import MemberWithdrawChartYear from './Chart/MemberWithdrawChartYear'
    import MemberBonusChart from './Chart/MemberBonusChart'
    import MemberBonusChartMonth from './Chart/MemberBonusChartMonth'
    import MemberBonusChartYear from './Chart/MemberBonusChartYear'

    import modal from './HeaderDropdown/Modal'
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "../modules/GenericHelper.js";
    import moment from 'moment'
    import { constPromoGroup, constPromoGroupType, constRejectReasonP, constRejectReasonD, constRejectReasonW, loadingFullScreen } from '@/modules/Constant.js'
    import { required, requiredIf, decimal } from 'vuelidate/lib/validators'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import DateRangePicker from 'vue2-daterange-picker'
    import VueCircle from 'vue2-circle-progress'
    import { CChartLineSimple, CChartBarSimple } from '../views/charts/index.js'
    import { constAccessType } from '@/modules/Constant.js';
    import $ from 'jquery'

    export default {
        props: ['arry_san_length'],
        mixins: [genericHelper],
        computed: {
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess']),
            ...mapGetters('Language', ['getLanguage', "getLangCode"]),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion',
                'getPendingDeposit'
            ]),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            ...mapGetters('SMBData', [
                'getCurrencyCode'
            ]),

        },
        name: 'DashboardOperation',
        components: {
            MemberChart,
            MemberRegisterChart,
            NewRegisterChartMonth,
            NewRegisterChartYear,
            MemberOnlineChart,
            MemberOnlineChartMonth,
            MemberOnlineChartYear,
            MemberWithdrawChart,
            MemberWithdrawChartMonth,
            MemberWithdrawChartYear,
            MemberDepositChart,
            MemberDepositChartMonth,
            MemberDepositChartYear,
            MemberBonusChart,
            MemberBonusChartMonth,
            MemberBonusChartYear,
            modal,
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker,
            CChartLineSimple,
            CChartBarSimple,
            VueCircle
        },

        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_fingerPrintLoading: [], // fingerprint/lastSystemID
                opened: [],
                arry_visitorMembers: [],
                arry_systemId: [],
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: false,
                checkDetails: 1,
                arry_mptl: [], // member promotion transaction list
                arry_rpl: [],
                arry_SA: [],//maintenance list
                arry_bl: [],//bank list
                showChart: "",
                setMemberOnline: 0,
                setCSOnline: 0,
                setTotalMember: 0,
                setTotalMemberWithBalance: 0,
                setTotalMainWallet: 0,
                setTotalPromoWallet: 0,
                setPendingDeposit: 0,
                setPendingWithdraw: 0,
                setPendingPromotion: 0,
                bool_showDetails: false,
                showPromoDetails: false,
                showGameMaintenance: false,
                showBankAccount: false,
                bool_showAllTransaction: false,
                bool_showMoreTransactionBtn: false,
                obj_member: {},
                arr_TransactionList: [],
                selected: 'Day',
                newRegisterselected: 'Day',
                memberOnlineselected: 'Day',
                memberDepositselected: 'Day',
                memberWithdrawselected: 'Day',
                memberBonusselected: 'Day',
                SummaryArray: [],
                MemberDepositChartData: [],
                MemberDepositChartLabel: [],
                MemberDepositChartDate: '',
                MemberDepositTotalCount: 0,
                MemberWithdrawChartData: [],
                MemberWithdrawChartLabel: [],
                MemberBonusChartData: [],
                MemberBonusChartLabel: [],
                MemberBonusChartDate: '',
                MemberWithdrawChartDate: '',
                MemberWithdrawTotalCount: 0,
                MemberBonusTotalCount: 0,
                MemberRegisterChartData: [],
                MemberRegisterChartLabel: [],
                dd_membankname: [],
                mamBankAcc: null,
                obj_GetStartDate: {
                    ATS: "0001-01-01T00:00:00"
                },
                obj_GetEndDate: {
                    CTS: "0001-01-01T00:00:00",
                },
                searchCreatedTS: { startDate: this.getTodayDate(), endDate: this.getTodayDate() },
                MemberRegisterChartDate: '',
                MemberRegisterTotalCount: 0,
                selectedDateTS: {
                    startDate: this.getTodayDate(),
                    endDate: this.getTodayDate()
                },

                //transaction, promotion data
                bool_CV: false, // Check Validation
                bool_bankCV: false, // Check Bank Validation
                bool_isAMVD: false, // Deposit Add Modal Visible
                bool_isRMVD: false, // Deposit Reject Modal Visible
                bool_isAMVW: false, // Withdraw Add Modal Visible
                bool_isRMVW: false, // Withdraw Reject Modal Visible
                bool_isRMVP: false, // Promotion Reject Modal Visible
                bool_isABA: false, // Add Bank Modal Visible
                bool_fullPreview: false,
                obj_ad: [], // add deposit
                obj_aw: [], // add Withdraw
                dd_agentgroup: [],//agent group option
                searchCurrency: null,
                convertCurrency: null,
                searchAgent: null,
                dd_bank: [],
                dd_bankacc: [],
                dd_currency: [],
                dd_currency1: [],
                dd_rejectreason: [],
                obj_Reject: {
                    "I": "",
                    "reason": null,
                    "reason2": "",
                    "R": ""
                },
                constAccessType: constAccessType,
                obj_bank: {},
                ErrBAAmount: "",
                editBankIndex: -1,
                AutoUpdateTO: null,
                bool_isCrypto: false,
                previewUrl: null,
                bool_isShowDeposit: false,
                bool_isShowWithdraw: false,
                bool_isShowBonus: false,
                bool_isShowOnline: false, // hui lee temp hide
                bool_isShowRegister: true, // hui lee temp hide
                DB_Month: "",
                DB_TDay: "",
                DB_CDay: "",
                DB_DProgress: "",
                DB_DRefresh: "-",
                View_acce: false,
                searchAgent: null,
                searchCurrency: null,
                CurrencySymbolShow: "",
                alreadyLoad: false,
                prevCurrencyCode: null
            }
        },
        validations: {
            obj_bank: {
                BNI: { required },
                BAI: { required },
                TA: { decimal, required },
            },
            obj_ad: {
                BNI: { required },
                BAI: { required },
                TA: { decimal, required },
                RR: {
                    required: requiredIf(function (vm) {
                        return this.bool_isRMVD;
                    }),
                },
            },
            obj_aw: {
                MB: {
                    required: requiredIf(function (vm) {
                        return !this.bool_isCrypto;
                    }),
                },
                MBA: {
                    required: requiredIf(function (vm) {
                        return !this.bool_isCrypto;
                    }),
                },
                MBN: {
                    required: requiredIf(function (vm) {
                        return !this.bool_isCrypto;
                    }),
                },
                TA: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return !this.bool_isCrypto
                    }),
                },
                RR: {
                    required: requiredIf(function (vm) {
                        return this.bool_isRMVW;
                    }),
                },
            }
        },
        methods: {
            getDateRange(showThisYear = false) {
                var that = this;
                var dateRange = {
                    [that.getLanguage['MEM']['TODAY']] : [moment(), moment()],
                    [that.getLanguage['MEM']['YESDAY']]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    [that.getLanguage['MEM']['TWEEK']]: [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                    [that.getLanguage['MEM']['TMON']]: [moment().startOf('month'), moment().endOf('month')],
                    [that.getLanguage['MEM']['TYEAR']]: [moment().startOf('year'), moment().endOf('year')],
                    [that.getLanguage['MEM']['LWEEK']]: [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')],
                    [that.getLanguage['MEM']['LMON']]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                }
                if (!showThisYear)
                    delete dateRange[that.getLanguage['MEM']['TYEAR']];
                return dateRange;
            },
            changeChart(showChart) {
                this.bool_isFirstLoad = false;

                if (this.showChart == showChart)
                    this.showChart = "";
                else
                    this.showChart = showChart;
            },
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            CurrencyChange(value) {
                this.setThousandCurrency(this.CheckIsThousandCurrency(value, this), this);
            },
            close(int_Type) {
                this.bool_CV = false;
                if (int_Type == 1) {
                    this.bool_isAMVD = !this.bool_isAMVD;
                } else if (int_Type == 2) {
                    this.bool_isAMVW = !this.bool_isAMVW;
                    this.ErrBAAmount = "";
                }

            },
            MLPage() {
                if (this.searchAgent) {
                    var agiList = this.searchAgent.split('-');
                    var agi = agiList[1];
                } else {
                    var agi = null;
                }

                let routeData = this.$router.resolve({ path: '/M/ML', query: { agi: agi, ci: this.searchCurrency, cb: 1} });
                window.open(routeData.href, '_blank');
            },
            PDPage() {
                let routeData = this.$router.resolve({ path: '/D/DDU', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            PWPage() {
                let routeData = this.$router.resolve({ path: '/W/WDU', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            PBPage() {
                let routeData = this.$router.resolve({ path: '/P/PDU', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            MemberOnline() {
                let routeData = this.$router.resolve({ path: '/M/MO', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            CSOnline() {
                let routeData = this.$router.resolve({ path: '/DASH/CSO', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            BAPage() {
                let routeData = this.$router.resolve({ path: '/B/ACL', query: { agi: this.searchAgent, ci: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
            DailyPromoPage(PCvalue, PFTSvalue, PTTSvalue, TT) {
                if (TT == 1) {
                    let routeData = this.$router.resolve({ path: '/R/PR', query: { pc: PCvalue, pf: PFTSvalue, pt: PTTSvalue } });
                    window.open(routeData.href, '_blank');
                }
                else if (TT == 2) {
                    let routeData = this.$router.resolve({ path: '/R/LR', query: { pc: PCvalue, pf: null, pt: null } });
                    window.open(routeData.href, '_blank');
                }
                else if (TT == 3 || TT == 4) {
                    let routeData = this.$router.resolve({ path: '/R/DLSR', query: { pc: PCvalue, df: null, dt: null } });
                    window.open(routeData.href, '_blank');
                }
            },
            SAPage(value) {
                let routeData = this.$router.resolve({ path: '/DASH/AA', query: { fr: value } });
                window.open(routeData.href, '_blank');
            },
            closeReject(int_Type) {
                this.bool_CV = false;
                if (int_Type == 1) {
                    this.bool_isRMVD = !this.bool_isRMVD;
                } else if (int_Type == 2) {
                    this.bool_isRMVW = !this.bool_isRMVW;
                } else if (int_Type == 3) {
                    this.bool_isRMVP = !this.bool_isRMVP;
                }
            },
            closeAddBank() {
                this.bool_isABA = !this.bool_isABA;
                this.bool_bankCV = false;
                this.obj_bank = {
                    BN: null,
                    BNI: null,
                    BAI: null,
                    BA: null,
                    TA: null
                }
                this.dd_bankacc = [];
                this.editBankIndex = -1;
            },
            closePreview() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            addBank() {
                this.obj_bank = {
                    BN: null,
                    BNI: null,
                    BAI: null,
                    BA: null,
                    TA: null
                }
                this.bool_isABA = true;
                this.editBankIndex = -1;
            },
            saveBank() {
                if (this.obj_bank.TA == 0) {
                    this.obj_bank.TA = null;
                }
                this.bool_bankCV = true;
                this.$v.obj_bank.$touch();
                if (!this.$v.obj_bank.$error) {
                    var exist = false;
                    if (!this.obj_aw.BankList) {
                        this.obj_aw.BankList = [];
                    }
                    for (var pt of this.dd_bank) {
                        if (pt.id == this.obj_bank['BNI']) {
                            this.obj_bank['BN'] = pt.label;
                        }
                    }
                    for (var pt of this.dd_bankacc) {
                        if (pt.id == this.obj_bank['BAI']) {
                            this.obj_bank['BA'] = pt.label;
                        }
                    }

                    for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                        if (this.obj_aw.BankList[i].BAI == this.obj_bank.BAI && this.editBankIndex != i) {
                            exist = true;
                            break;
                        }
                    }

                    if (!exist && this.editBankIndex != -1) {
                        this.obj_aw.BankList[this.editBankIndex] = this.obj_bank;
                    }
                    else if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"]["BAN"]), 1000);
                    }
                    else {
                        this.obj_aw.BankList.push(this.obj_bank);
                    }

                    this.bool_isABA = false;
                    this.bool_bankCV = false;
                    this.obj_bank = {};
                    this.dd_bankacc = [];
                }
            },
            removeBank(index) {
                this.$delete(this.obj_aw.BankList, index);
                this.$forceUpdate();
            },
            editBank(data, index) {
                this.bool_bankCV = false;
                this.obj_bank = Object.assign({}, data);
                this.BankNameChange(this.obj_bank.BNI, 2, true);
                this.bool_isABA = true;
                this.editBankIndex = index;
            },
            BankNameChange(value, int_Type, isEdit = false) {
                if (int_Type == 1) {
                    if (value != undefined) {
                        this.obj_ad['BAI'] = null;
                        this.dd_bankacc = [];
                        var that = this;
                        this.getDataApi(`/api/dd/bankacc/` + value + "/" + that.obj_ad.AGI + "/" + 1,
                            function (d, s) {
                                if (s) {
                                    that.dd_bankacc = d.dropdownlist;
                                    that.$forceUpdate();
                                }
                            });
                    }
                } else if (int_Type == 2) {
                    if (value != undefined) {
                        if (!isEdit) {
                            this.obj_bank['BAI'] = null;
                        }
                        this.dd_bankacc = [];
                        var that = this;
                        this.getDataApi(`/api/dd/bankacc/` + value + "/" + that.obj_aw.AGI + "/2/" + that.obj_aw.CI,
                            function (d, s) {
                                if (s) {
                                    that.dd_bankacc = d.dropdownlist;
                                    that.$forceUpdate();
                                }
                            });
                    }
                }

            },
            CalculateRemainAmount(TA, CS) {
                if (this.obj_aw.BankList != null) {
                    var amount = 0;
                    for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                        amount += parseFloat(this.obj_aw.BankList[i].TA);
                    }
                    TA -= amount;
                    return this.formatNumber(TA, '.', ',', 2, CS);
                }
                else {
                    return this.formatNumber(TA, '.', ',', 2, CS);
                }
            },
            ValidationBankErrMsg(value, langKey = "") {
                if (this.bool_bankCV) {
                    var validateObj = this.$v.obj_bank[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                    }
                }
            },
            ValidationErrMsg(value, langKey = "", int_Type) {

                if (this.bool_CV) {

                    if (int_Type == 1) {
                        var validateObj = this.$v.obj_ad[value];

                        if (validateObj.required != undefined && !validateObj.required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                        }
                        else if (validateObj.decimal != undefined && !validateObj.decimal) {
                            return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                        }
                    } else if (int_Type == 2) {

                        var validateObj = this.$v.obj_aw[value];

                        if (validateObj.required != undefined && !validateObj.required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                        }
                        else if (validateObj.decimal != undefined && !validateObj.decimal) {
                            return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                        }
                    } else if (int_Type == 3) {
                        var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;
                        if (rejectreason == "" && rejectreason == null) {
                            return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["PM"][langKey]);
                        }
                    }

                }

            },
            approveTransaction(int_Type) {
                this.bool_CV = true;

                if (int_Type == 1) {
                    this.$v.obj_ad.$touch();
                    if (!this.$v.obj_ad.$error) {

                        this.$fire({
                            title: this.getLanguage["MTA"]["CA"],
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["YES"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                var that = this;

                                this.bool_fullLoading = true;
                                this.obj_ad['AC'] = 2;
                                this.obj_ad['RS'] = 2;
                                this.obj_ad['DSRT'] = "::[MTA][DST]::";
                                this.obj_ad['DSRM'] = "::[MTA][DSM]::";

                                this.obj_ad['PSRT'] = "::[PM][PST]::";
                                this.obj_ad['PSRM'] = "::[PM][PST]::";

                                for (var i = 0; i < this.dd_membankname.length; i++) {
                                    if (this.mamBankAcc == this.dd_membankname[i].id) {
                                        var accountData = this.dd_membankname[i].label.split('-');
                                        this.obj_ad['MB'] = accountData[0];
                                        this.obj_ad['MBA'] = accountData[1];
                                        this.obj_ad['MBN'] = accountData[2];
                                    }
                                }

                                this.postDataApi(`/api/memtrans/ap`, this.obj_ad,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        if (s) {
                                            that.bool_isAMVD = false;
                                            that.bool_CV = false;
                                            //that.getMemberPromoTransList();
                                            that.showApproveSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.DIS"));

                                        }
                                    });
                            }
                        });
                    }
                } else if (int_Type == 2) {
                    this.ErrBAAmount = "";
                    var transAmount = 0;
                    if (this.obj_aw.BankList) {
                        for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                            transAmount += parseFloat(this.obj_aw.BankList[i].TA);
                        }
                    }

                    if (!this.obj_aw.BankList) {
                        this.ErrBAAmount = String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"]["CAD"]);;
                    }
                    else if (transAmount.toFixed(this.getThousandCurrency ? 3 : 2) != parseFloat(this.obj_aw.TA.toFixed(this.getThousandCurrency ? 3 : 2))) {
                        this.ErrBAAmount = this.getLanguage["MTA"]["ErrAmount"];
                    }
                    else {
                        this.$v.obj_aw.$touch();
                        if (!this.$v.obj_aw.$error) {

                            this.$fire({
                                title: this.getLanguage["MTA"]["CA"],
                                width: '30em',
                                showCancelButton: true,
                                confirmButtonText: this.getLanguage["GL"]["YES"],
                                cancelButtonText: this.getLanguage["CNO"]["NO"],
                                reverseButtons: true,
                                customClass: {
                                    title: 'afb-alert-title',
                                    content: 'afb-alert-content',
                                    actions: 'afb-alert-action'
                                }
                            }).then((result) => {
                                if (result.value == true) {
                                    var that = this;

                                    this.bool_fullLoading = true;
                                    this.obj_aw['AC'] = 2;
                                    this.obj_aw['RS'] = 2;
                                    this.obj_aw['IITO'] = 0;
                                    this.obj_aw['WSRT'] = "::[MTA][WST]::";   //this.getLanguage["MTA"]["WST"];
                                    this.obj_aw['WSRM'] = "::[MTA][WSM]::";   //this.getLanguage["MTA"]["WSM"];

                                    this.postDataApi(`/api/memtrans/ap`, this.obj_aw,
                                        function (d, s) {
                                            that.bool_fullLoading = false;
                                            if (s) {
                                                if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 9001) {

                                                    that.$fire({
                                                        title: that.getLanguage["MTA"]["CA"],
                                                        html: that.getLanguage["MTA"]["CIITO"],
                                                        width: '30em',
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Ok',
                                                        cancelButtonText: 'Cancel',
                                                        reverseButtons: true,
                                                        customClass: {
                                                            title: 'afb-alert-title',
                                                            content: 'afb-alert-content',
                                                            actions: 'afb-alert-action'
                                                        }
                                                    }).then((result) => {
                                                        if (result.value == true) {
                                                            that.bool_fullLoading = true;
                                                            that.obj_aw['IITO'] = 1;
                                                            that.postDataApi(`/api/memtrans/ap`, that.obj_aw,
                                                                function (d, s) {
                                                                    that.bool_fullLoading = false;
                                                                    if (s) {
                                                                        that.bool_isAMVW = false;
                                                                        that.bool_CV = false;
                                                                        that.ErrBAAmount = "";
                                                                        //that.getMemberPromoTransList();
                                                                        that.showApproveSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.WIS"));

                                                                    }
                                                                });
                                                        }
                                                    });
                                                }
                                                else {
                                                    that.bool_isAMVW = false;
                                                    that.bool_CV = false;
                                                    that.ErrBAAmount = "";
                                                    //that.getMemberPromoTransList();
                                                    that.showApproveSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.WIS"));

                                                }

                                            }
                                        });
                                }
                            });
                        }
                    }
                }

            },
            approveCryptoWithdraw() {

                this.bool_CV = true;
                this.ErrBAAmount = "";

                var transAmount = 0;
                this.$v.obj_aw.$touch();
                if (!this.$v.obj_aw.$error) {

                    this.$fire({
                        title: this.getLanguage["MTA"]["CA"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            var that = this;
                            this.bool_fullLoading = true;
                            this.obj_aw['AC'] = 2;
                            this.obj_aw['RS'] = 2;
                            this.obj_aw['IITO'] = 0;
                            this.obj_aw['WSRT'] = "::[MTA][WST]::";     //this.getLanguage["MTA"]["WST"];
                            this.obj_aw['WSRM'] = "::[MTA][WSM]::";     //this.getLanguage["MTA"]["WSM"];
                            this.postDataApi(`/api/memtrans/ap`, this.obj_aw,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 9001) {
                                            that.$fire({
                                                title: that.getLanguage["MTA"]["CA"],
                                                html: that.getLanguage["MTA"]["CIITO"],
                                                width: '30em',
                                                showCancelButton: true,
                                                confirmButtonText: 'Ok',
                                                cancelButtonText: 'Cancel',
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            }).then((result) => {
                                                if (result.value == true) {
                                                    that.bool_fullLoading = true;
                                                    that.obj_aw['IITO'] = 1;
                                                    that.postDataApi(`/api/memtrans/ap`, that.obj_aw,
                                                        function (d, s) {
                                                            that.bool_fullLoading = false;
                                                            if (s) {
                                                                //that.bool_isAMV = false;
                                                                that.ErrBAAmount = "";
                                                                //that.getMemberPromoTransList();
                                                            }
                                                        });
                                                }
                                            });
                                        }
                                        else {
                                            that.bool_isAMV = false;
                                            that.ErrBAAmount = "";
                                            //that.getMemberPromoTransList();
                                        }
                                    }
                                });
                        }
                    });
                }
            },
            rejectTransaction(int_Type) {
                this.bool_CV = true;

                if (int_Type == 1) {

                    var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;

                    if (rejectreason != "" && rejectreason != null) {

                        this.$fire({
                            title: this.getLanguage["MTA"]["CR"],
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["YES"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                var that = this;

                                this.bool_fullLoading = true;
                                this.obj_ad['RR'] = rejectreason;
                                this.obj_ad['AC'] = 3;
                                this.obj_ad['RS'] = 3;
                                this.obj_ad['DSRT'] = "::[MTA][DRT]::";
                                this.obj_ad['DSRM'] = "::[MTA][DRM]::";

                                this.obj_ad['PSRT'] = "::[PM][PCT]::";
                                this.obj_ad['PSRM'] = "::[PM][PCM]::";
                                this.obj_ad['PRR'] = this.getLanguage["PM"]["PRR"];

                                this.postDataApi(`/api/memtrans/ap`, this.obj_ad,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        if (s) {
                                            that.bool_isRMVD = false;
                                            that.bool_CV = false;
                                            //that.getMemberPromoTransList();
                                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        }
                                    });
                            }
                        });
                    }
                } else if (int_Type == 2) {

                    var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;

                    if (rejectreason != "" && rejectreason != null) {

                        this.$fire({
                            title: this.getLanguage["MTA"]["CR"],
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["YES"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                var that = this;

                                this.bool_fullLoading = true;
                                this.obj_aw['RR'] = rejectreason;
                                this.obj_aw['AC'] = 3;
                                this.obj_aw['RS'] = 3;
                                this.obj_aw['WSRT'] = "::[MTA][WRT]::";
                                this.obj_aw['WSRM'] = "::[MTA][WRM]::";

                                this.postDataApi(`/api/memtrans/ap`, this.obj_aw,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        if (s) {
                                            that.bool_isRMVW = false;
                                            that.bool_CV = false;
                                            //that.getMemberPromoTransList();
                                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        }
                                    });
                            }
                        });
                    }
                } else if (int_Type == 3) {

                    var that = this;

                    var rejectreason = that.obj_Reject.reason == 999 ? that.obj_Reject.reason2 : that.obj_Reject.reason;

                    if (rejectreason != "" && rejectreason != null) {

                        this.$fire({
                            title: this.getLanguage["PM"]["CRE"],
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["YES"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                that.bool_fullLoading = true;

                                var dt = {
                                    I: that.obj_Reject.I,
                                    UTS: that.obj_Reject.UTS,
                                    AC: 3,
                                    RR: rejectreason,
                                    R: that.obj_Reject.R,
                                    PSRT: "::[PM][PRT]::",
                                    PSRM: "::[PM][PRM]::",
                                };

                                that.postDataApi(`/api/mpromo/ap`, dt,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        if (s) {
                                            that.bool_isRMVP = false;
                                            that.bool_CV = false;
                                            //that.getMemberPromoTransList();
                                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        }
                                    });
                            }
                        });
                    }
                }
            },
            showMoreDetails(value) {
                //running promotion
                if (value == 1) {
                    this.showPromoDetails = true;
                }
                //game under maintenance
                else if (value == 2) {
                    this.showGameMaintenance = true;
                }
                else if (value == 3) {
                    this.showBankAccount = true;
                }
            },
            ViewPromo(id) {
                this.bool_fullLoading = true;
                this.obj_GetStartDate.ATS = "";
                this.obj_GetEndDate.CTS = "";
                var that = this;
                this.getDataApi(`/api/dc/gE/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.obj_GetEndDate.CTS = "";
                            that.setPromo_V(d.D, 'ed', id);
                        }
                    });
                this.getDataApi(`/api/dc/gS/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d.D.GetATS[0] == null) {
                                that.getDataApi(`/api/dc/DT/${id}`,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        if (s) {
                                            that.obj_GetStartDate = "";
                                            that.setPromo_V(d.D.GetDepositTS, 'dd', id);
                                        }
                                    });
                            }
                            else {
                                that.obj_GetStartDate = "";
                                that.setPromo_V(d.D, 'sd', id);

                            }
                        }
                    });

            },
            setPromo_V(data, name, id) {
                if (name == 'sd') {
                    //promo
                    this.obj_GetStartDate = Object.assign(this.obj_GetStartDate, data.GetATS[0]);
                    this.checkDetails = 1;
                }
                else if (name == 'dd') {
                    this.obj_GetStartDate = {
                        //deposit
                        ATS: data,
                    };
                }
                else {
                    //withdraw
                    this.obj_GetEndDate = Object.assign(this.obj_GetEndDate, data);
                    this.checkDetails = 2;
                }
                this.bool_showDetails = true;
                this.searchCreatedTS.endDate = this.obj_GetEndDate.CTS;
                this.searchCreatedTS.startDate = this.obj_GetStartDate.ATS;
                if (this.obj_GetEndDate.CTS && this.obj_GetStartDate.ATS)
                    this.getTransactionData(id);
                this.getData(id);
            },
            getData(id) {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/dc/gmbc/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.obj_member = Object.assign(that.obj_member, d.D);
                        }
                    });
            },
            getTransactionData(id) {
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }
                path += "&f.RT=1";
                path += "&f.MI=" + id;
                path += "&f.STS_from=" + this.obj_GetStartDate.ATS;
                path += "&f.STS_to=" + this.obj_GetEndDate.CTS;

                // path += "&f.TT=1";
                // path += "&f.I=" + id;
                // path += "&f.StartDate=" + this.obj_GetStartDate.ATS;
                // path += "&f.EndDate=" + this.obj_GetEndDate.CTS;

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }
                this.arr_TransactionList = [];

                var that = this;
                this.bool_fullLoading = true;
                this.getDataApi(`/api/dc/lgt?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_showAllTransaction = false;
                        that.bool_showMoreTransactionBtn = false;

                        if (s) {
                            if (d.D != null) {
                                that.int_TP = 1;
                                that.int_Total = d.D.length;
                                that.arr_TransactionList = d.D;

                                if (that.int_RC == 50) {
                                    that.bool_showAllTransaction = that.int_Total > 50;
                                }
                                else if (that.int_Total > 5) {
                                    that.bool_showMoreTransactionBtn = false;
                                }
                            }
                        }
                    });
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.endDate = this.obj_GetEndDate.CTS;
                this.searchCreatedTS.startDate = this.obj_GetStartDate.ATS;
            },
            assignRequest(bool_isTakeover, d, index) {
                this.bool_fullLoading = true;
                var that = this;

                var dt = {
                    I: d.I,
                    UTS: d.UTS,
                    AC: bool_isTakeover ? 11 : 12
                };

                if (d.T == 3) {
                    this.postDataApi(`/api/mpromo/ao`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.$refs["dd_assignto_" + index][0].visible = false;
                                //that.getMemberPromoTransList();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                }
                else {
                    this.postDataApi(`/api/memtrans/ao`, dt,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.$refs["dd_assignto_" + index][0].visible = false;
                                //that.getMemberPromoTransList();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });
                }
            },
            changeApproval(bool_isApproved, d, index) {
                if (d.T == 1) {

                    var that = this;
                    this.dd_membankname = [];
                    this.getDataApi(`/api/memtrans/g/${d.I}`,
                        function (d, s) {
                            if (s) {
                                that.obj_ad = Object.assign({}, d.D);
                                that.bool_fullLoading = true;
                                that.CurrencyChange(that.obj_ad.CS);

                                if (bool_isApproved) {
                                    that.getDataApi(`/api/dd/memberbankname/` + that.obj_ad.MI,
                                        function (a, s) {
                                            if (s) {
                                                that.dd_membankname = a.dropdownlist;
                                            }
                                        });
                                    that.getDataApi(`/api/dd/bank/` + that.obj_ad.AGI + "/" + 1,
                                        function (d, s) {
                                            if (s) {
                                                that.dd_bank = d.dropdownlist;
                                            }
                                        });


                                    that.getDataApi(`/api/dd/bankacc/` + that.obj_ad.BNI + "/" + that.obj_ad.AGI + "/" + 1,
                                        function (d, s) {
                                            if (s) {
                                                that.dd_bankacc = d.dropdownlist;
                                                that.bool_isAMVD = true;
                                                that.bool_fullLoading = false;
                                            }
                                        });
                                } else {
                                    that.dd_rejectreason = constRejectReasonD;
                                    that.obj_Reject = {
                                        reason: null,
                                        reason2: ""
                                    };
                                    that.bool_isRMVD = true;
                                    that.bool_fullLoading = false;
                                }


                            }
                        });
                }
                else if (d.T == 2) {

                    var that = this;

                    this.getDataApi(`/api/memtrans/g/${d.I}`,
                        function (d, s) {
                            if (s) {
                                that.obj_aw = Object.assign({}, d.D);
                                that.bool_fullLoading = true;
                                that.CurrencyChange(that.obj_aw.CS);

                                if (bool_isApproved) {
                                    that.getDataApi(`/api/dd/bank/` + that.obj_aw.AGI + "/2/" + that.obj_aw.CI,
                                        function (d, s) {
                                            if (s) {
                                                that.dd_bank = d.dropdownlist;
                                            }
                                        });

                                    if (that.obj_aw.BNI == null || that.obj_aw.BNI == 0) {
                                        that.obj_aw.BNI = null;
                                        that.obj_aw.BAI = null;
                                    }

                                    that.bool_isAMVW = true;
                                    that.bool_fullLoading = false;

                                } else {
                                    that.dd_rejectreason = constRejectReasonW;
                                    that.obj_Reject = {
                                        reason: null,
                                        reason2: ""
                                    };
                                    that.bool_isRMVW = true;
                                    that.bool_fullLoading = false;
                                }


                            }
                        });
                }
                else if (d.T == 3) {
                    var that = this;

                    if (bool_isApproved) {

                        this.$fire({
                            title: this.getLanguage["PM"]["CAE"],
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["YES"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                that.bool_fullLoading = true;

                                if (d.DB == 25 || d.DB == 26) {
                                    var obj_Comm = {
                                        "AC": 1,
                                        "CNT": "",
                                        "CNM": "",
                                        "R": [],
                                    };
                                    obj_Comm["AC"] = 2;
                                    obj_Comm["R"] = [];
                                    obj_Comm["CNT"] = d.DB == 25 ? this.getLanguage["PM"]["CNT1"] : this.getLanguage["PM"]["CNT2"];
                                    obj_Comm["CNM"] = d.DB == 25 ? this.getLanguage["PM"]["CNM1"] : this.getLanguage["PM"]["CNM2"];

                                    obj_Comm.R.push({
                                        "I": d.I,
                                    });

                                    that.postDataApi(`/api/mpromo/sc`, obj_Comm,
                                        function (d, s) {
                                            that.bool_fullLoading = false;
                                            if (s) {
                                                //that.getMemberPromoTransList();
                                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                            }
                                        });
                                }
                                else {
                                    var dt = {
                                        I: d.I,
                                        UTS: d.UTS,
                                        AC: 2,
                                        PSRT: "::[PM][PST]::",  // this.getLanguage["PM"]["PST"],
                                        PSRM: "::[PM][PST]::",   //this.getLanguage["PM"]["PST"],
                                    };

                                    that.postDataApi(`/api/mpromo/ap`, dt,
                                        function (d, s) {
                                            that.bool_fullLoading = false;
                                            if (s) {
                                                that.$refs["dd_status_" + index][0].visible = false;
                                                //that.getMemberPromoTransList();
                                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                            }
                                        });
                                }
                            }
                        });
                    }
                    else if (d.DB == 25 || d.DB == 26) {
                        this.$fire({
                            title: this.getLanguage["PM"]["CRE"],
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["YES"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                this.bool_fullLoading = true;
                                var that = this;

                                var obj_Comm = {
                                    "AC": 1,
                                    "CNT": "",
                                    "CNM": "",
                                    "R": [],
                                };
                                obj_Comm["AC"] = 3;
                                obj_Comm["R"] = [];

                                obj_Comm.R.push({
                                    "I": d.I,
                                });

                                this.postDataApi(`/api/mpromo/sc`, obj_Comm,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        if (s) {
                                            //that.getMemberPromoTransList();
                                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        }
                                    });
                            }
                        });
                    }
                    else {
                        that.dd_rejectreason = constRejectReasonP;
                        that.obj_Reject = {
                            I: d.I,
                            UTS: d.UTS,
                            AC: 3,
                            reason: null,
                            reason2: "",
                            R: ""
                        };

                        that.bool_isRMVP = true;
                    }
                }

            },
            changeCryptoApproval(bool_isApproved, d, index) {
                this.bool_CV = false;
                var that = this;

                this.getDataApi(`/api/memtrans/g/${d.I}`,
                    function (d, s) {
                        if (s) {
                            that.obj_aw = Object.assign({}, d.D);
                            that.bool_fullLoading = false;

                            if (bool_isApproved) {
                                //that.obj_aw = Object.assign({}, d);
                                that.bool_isCrypto = true;
                                that.approveCryptoWithdraw();

                            } else {
                                //that.obj_aw = Object.assign({}, d);
                                that.dd_rejectreason = constRejectReasonW;
                                that.obj_Reject = {
                                    reason: null,
                                    reason2: ""
                                };
                                that.bool_isRMVW = true;
                            }


                        }
                    });

            },
            canChangeStatus(canUpdateStatus, paymentMethod) {
                if (paymentMethod == 5)
                    return false;
                else if (!canUpdateStatus)
                    return false;

                return true;
            },
            ctrPage(newPage) {
                this.int_Page = newPage;
                if (newPage > this.int_TP) {
                    this.int_Page = this.int_TP;
                }
                if (newPage <= 0) {//here set the limit of the label num
                    this.int_Page = 1;
                }
                //this.getMemberPromoTransList();
            },
            color(value) {
                let $color
                if (value <= 25) {
                    $color = 'info'
                } else if (value > 25 && value <= 50) {
                    $color = 'success'
                } else if (value > 50 && value <= 75) {
                    $color = 'warning'
                } else if (value > 75 && value <= 100) {
                    $color = 'danger'
                }
                return $color
            },
            showpercent(value) {
                if (value > 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.searchAgent = null;
                }
                this.searchCurrency = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            getMemberPromoTransList() {
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var agi = 0;
                var ci = null;
                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                if (this.searchCurrency != null) {
                    ci = this.searchCurrency;
                }
                this.getDataApi(`/api/dc/mpt?${path}&f[AGI]=${agi}&f[CI]=${ci}`,
                    function (d, s) {
                        if (s) {
                            that.setMemberPromoTransList(d.D);
                        }
                    });
            },
            setMemberPromoTransList(data) {
                this.arry_mptl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);
                this.int_TI = data.TotalItems;
            },
            getDashboardRunningPromotion() {
                var that = this;
                var agi = 0;
                var ci = null;
                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                if (this.searchCurrency != null) {
                    ci = this.searchCurrency;
                }
                this.getDataApi(`/api/dc/rp/${agi}/${ci}`,
                    function (d, s) {
                        if (s) {
                            that.arry_rpl = []
                            that.arry_rpl = d;
                        }
                    });
            },
            getSANList() {
                this.bool_fullLoading = true;
                var that = this;
                var that = this;
                var currentLang = this.getLangCode;  //set current language, display EN for default

                var now = moment().format("YYYY-MM-DDTHH:mm:ss");
                var agi = null;
                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                var path = `p=1&n=20&s=AI&d=true&f[L_csv]=${currentLang}&f[STS_to]=${now}&f[ETS_from]=${now}&f[AGI]=${agi}`;

                this.getDataApi(`/api/aann/laann?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.arry_SA = d.D.Items;
                        }
                    });
            },
            changeColor(valuebc, valuebb) {
                var result = "black";
                if (valuebc > valuebb && valuebb > 0) {
                    result = "red";
                }
                return {
                    color: result
                };
            },
            changeBackgroudColor(value, dataBB) {
                var result = "white";
                if (value > 0 && value <= 90) {
                    result = "#d3fdd5";
                }
                if (value > 90 && dataBB > 0) {
                    result = '#feccc9';
                }
                if (value > 0 && dataBB == 0) {
                    result = '#d3fdd5';
                }
                return {
                    'background-color': result
                };
            },
            getBankList() {
                var that = this;
                var agi = 0;
                var ci = null;
                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                if (this.searchCurrency != null) {
                    ci = this.searchCurrency;
                }
                this.getDataApi(`/api/dc/bl/${agi}/${ci}`,
                    function (d, s) {
                        if (s) {
                            that.arry_bl = d;
                        }
                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                                var at = 0;
                                at = that.dd_agentgroup[0].id.split("-")[0];
                                //if (at == 3 && that.dd_agentgroup.length < 2) {
                                //    that.searchAgent = that.dd_agentgroup[0].id;
                                //}
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getConvertCurrencyList() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency1 = d.dropdownlist;
                            if (that.dd_currency1.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.dd_currency1.length; i++) {
                                        if (that.dd_currency1[i].id == localStorage.getItem('CCUSD')) {
                                            that.convertCurrency = that.dd_currency1[i].id;
                                            break;
                                        }
                                    }
                                }
                                if (that.convertCurrency == null) {
                                    that.convertCurrency = that.dd_currency1[0].id;
                                }
                            }
                        }
                    });
            },            
            changeCurrency(array_C, cC, sC) {
                if (!this.alreadyLoad) {
                    return this.prevCurrencyCode;                    
                }                                               
                var z = "";
                var CTCI = cC;
                var CC = this.getCurrencyCode;
                
                for (var i = 0; i < array_C.length; i++) {
                    if (cC == null) {                        
                        localStorage.setItem('CCUSD', "");
                        if (array_C[i].label == CC) {
                            CTCI = array_C[i].id;
                            z = array_C[i].label;
                            break;
                        }
                        localStorage.setItem('CCUSD', CTCI);
                    }
                    else if (cC == array_C[i].id && cC != null) {
                        z = array_C[i].label;
                        break;
                    }
                    else if (sC == array_C[i].id && sC != null) {
                        z = array_C[i].label;
                    }
                }
                localStorage.setItem('CCUSD', cC);                                
                this.prevCurrencyCode = z;                
                return z;
            },
            getMemberOnlineMonitoring() {
                this.arry_memberOnline = [];
                var that = this;
                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                this.getDataApi(`/api/dc/aomo?p=&n=&s=RSN&d=true&f[AGI]=${agi}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            //var ao = 0;
                            //var mo = 0;
                            //for (var i = 0; i < d.D.Items.length; i++) {
                            //    if (d.D.Items[i].ICS != 1) {
                            //        mo += d.D.Items[i].TO;
                            //    }
                            //    else {
                            //        ao += d.D.Items[i].TO;
                            //    }
                            //}
                            that.setMemberOnline = d.Item1;
                            that.setCSOnline = d.Item2;
                        }
                    });
            },
            getDashboardPendingDeposit() {
                var that = this;
                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                this.getDataApi(`/api/dc/gpt?p=&n=&f[AGI]=${agi}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.setPendingDeposit = 0;
                            that.setPendingWithdraw = 0;
                            that.setPendingPromotion = 0;
                            for (var i = 0; i < d.length; i++) {
                                if (d[i].TT == 1) {
                                    that.setPendingDeposit = d[i].TP;
                                }
                                else if (d[i].TT == 2) {
                                    that.setPendingWithdraw = d[i].TP;
                                }
                                else {
                                    that.setPendingPromotion = d[i].TP;
                                }
                            }
                        }
                    });
            },
            getDashboardTotalMember(filterTotalBalance) {
                var that = this;
                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CI = this.searchCurrency;
                var CTCI = this.convertCurrency;
                if (CTCI == null) {
                    CTCI = localStorage.getItem('CCUSD');
                }

                if (CI != null && (CTCI == null || CTCI == '')) {
                    CTCI = CI;
                }                
                if (filterTotalBalance == null) {
                    filterTotalBalance = 0;                    
                }

                this.getDataApi(`/api/dc/gdtm?p=&n=&f[AGI]=${agi}&f[CI]=${CI}&f[CTCI]=${CTCI}&f[FTB]=${filterTotalBalance}`,
                    function (d, s) {
                        if (s) {
                            that.setTotalMember = d[0].TM;
                            that.setTotalMemberWithBalance = d[0].TMWB;
                            that.setTotalMainWallet = d[0].TMW;
                            that.setTotalPromoWallet = d[0].TPW;
                            that.CurrencySymbolShow = d[0].CS;
                            that.alreadyLoad = true;
                        }                        
                    });
            },

            CountItem(value) {
                if (this.int_Page > 1 && this.int_Page <= this.int_TP) {
                    return value + ((this.int_Page - 1) * this.int_RC);
                } else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                //this.getMemberPromoTransList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            renderPromotionCode(promotionCode, commissionType) {
                if (commissionType == 25) {
                    return this.getLanguage["PM"]["TOCM"];
                }
                else if (commissionType == 26) {
                    return this.getLanguage["PM"]["WLCM"];
                }
                return promotionCode;
            },
            renderPromotionGroup(int_promoGroup, int_conditionDurationType, int_conditionDurationValue) {
                var promoGroup = "";
                for (var i = 0; i < constPromoGroup.length; i++) {
                    for (var j = 0; j < constPromoGroup[i].children.length; j++) {
                        if (constPromoGroup[i].children[j].id == int_promoGroup) {
                            promoGroup = constPromoGroup[i].children[j].label;
                            break;
                        }
                    }
                }

                if (int_promoGroup == 3 || int_promoGroup == 5) {
                    var durationType = "";
                    for (var i = 0; i < constPromoGroupType.length; i++) {
                        if (constPromoGroupType[i].id == int_conditionDurationType) {
                            durationType = constPromoGroupType[i].label;
                            break;
                        }
                    }

                    promoGroup += " [" + int_conditionDurationValue + " " + durationType + "]";
                }

                return promoGroup;
            },
            renderPromotionTurnover(int_turnoverType, dec_turnoverValue, str_decimalSymbol, str_thousandSeperator, str_currencySymbol, dec_promoMaxAmount, dec_promoBonusRatio) {
                if (int_turnoverType == 1 || int_turnoverType == 4) {
                    dec_turnoverValue = Number(dec_turnoverValue);
                    return dec_turnoverValue.toFixed(0) + " * N";
                }
                else if (int_turnoverType == 3) {
                    dec_turnoverValue = Number(dec_turnoverValue);

                    if (dec_promoMaxAmount > 0) {
                        let maximumWithdrawTurnover = ((dec_promoMaxAmount * 100 / dec_promoBonusRatio) + dec_promoMaxAmount) * dec_turnoverValue;
                        return dec_turnoverValue.toFixed(0) + " * N (" +
                            this.getLanguage["PM"]["MAX"] + ": " + this.formatNumber(maximumWithdrawTurnover, str_decimalSymbol, str_thousandSeperator, 2, str_currencySymbol) + ")";
                    }
                    else {
                        return dec_turnoverValue.toFixed(0) + " * N";
                    }
                }
                else {
                    return this.formatNumber(Number(dec_turnoverValue), str_decimalSymbol, str_thousandSeperator, 2, str_currencySymbol);
                }
            },
            renderAssignedToColor(assignedTo) {
                return this.$parent.checkpendingColor(assignedTo);
            },
            renderAssignedTo(assignedTo, assignedToPrefixCode) {
                if (assignedTo == "") {
                    return this.getLanguage["GL"]["PEND"];
                } else {
                    return assignedTo + " (" + assignedToPrefixCode + ")";
                }
            },
            renderStatus(int_status) {
                switch (int_status) {
                    case 2:
                        return this.getLanguage["GL"]["APRD"];
                        break;
                    case 3:
                        return this.getLanguage["GL"]["REJD"];
                        break;
                    default:
                        return this.getLanguage["GL"]["PEND"];
                        break;
                }
            },
            renderStatusColor(int_status) {
                switch (int_status) {
                    case 2:
                        return "success";
                        break;
                    case 3:
                        return "danger";
                        break;
                    default:
                        return "dark";
                        break;
                }
            },
            renderActivityType(type, paymentMethod) {
                return this.getLanguage['DB']['T' + type] + (paymentMethod == 5 ? " (" + this.getLanguage["MTA"]["DPM5"] + ")" : "");
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            RenderProgressColor(pct) {
                if (pct <= 25) {
                    return { color: "#39f" };
                } else if (pct > 25 && pct <= 50) {
                    return { color: "#2eb85c" };
                } else if (pct > 50 && pct <= 75) {
                    return { color: "#f9b115" };
                } else if (pct > 75 && pct <= 100) {
                    return { color: "#e55353" };
                }
            },

            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }
            },
            renderStatusStyle(TA, TO) {
                if (TA > TO) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
            },
            SelectDate() {
                var startTS = moment(this.selectedDateTS.startDate, "YYYYMMDD").format("YYYYMMDD")
                var EndTS = moment(this.selectedDateTS.endDate, "YYYYMMDD").format("YYYYMMDD")

                if (startTS == EndTS) {
                    this.getMemberDepositHourlyData();
                    this.getMemberWithdrawHourlyData();
                    this.getMemberRegisterHourlyData();
                    this.getMemberBonusHourlyData();
                }
                else {
                    this.getMemberDepositDataByDateRange();
                    this.getMemberWithdrawDataByDateRange();
                    this.getMemberRegisterDataByDateRange();
                    this.getMemberBonusDataByDateRange();
                }
            },
            getMemberDepositHourlyData() {
                var that = this;
                that.MemberDepositChartData = [];
                that.MemberDepositChartLabel = [];
                that.MemberDepositTotalCount = 0;
                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CD = moment(this.selectedDateTS.startDate, "YYYYMMDD").format("YYYYMMDD");
                this.getDataApi(`/api/dc/lmths?p=&n=&s=CH&d=false&f[TT]=1&f[AGI]=${agi}&f[CD]=${CD}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.SummaryArray = d.D.Items;
                            that.MemberDepositChartData = [];
                            that.MemberDepositChartLabel = [];
                            that.MemberDepositTotalCount = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MemberDepositChartData.push(that.SummaryArray[i].DC);
                                that.MemberDepositChartLabel.push(that.SummaryArray[i].CH.toString().padStart(2, '0') + ':00');
                                that.MemberDepositTotalCount += that.SummaryArray[i].DC;
                            }
                            that.MemberDepositChartDate = that.format_date(that.SummaryArray[0].CD);
                        }
                    });
            },
            getMemberWithdrawHourlyData() {
                var that = this;
                that.MemberWithdrawChartData = [];
                that.MemberWithdrawChartLabel = [];
                that.MemberWithdrawTotalCount = 0;
                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CD = moment(this.selectedDateTS.startDate, "YYYYMMDD").format("YYYYMMDD")
                this.getDataApi(`/api/dc/lmths?p=&n=&s=CH&d=false&f[TT]=2&f[AGI]=${agi}&f[CD]=${CD}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.SummaryArray = d.D.Items;
                            that.MemberWithdrawChartData = [];
                            that.MemberWithdrawChartLabel = [];
                            that.MemberWithdrawTotalCount = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MemberWithdrawChartData.push(that.SummaryArray[i].DC);
                                that.MemberWithdrawChartLabel.push(that.SummaryArray[i].CH.toString().padStart(2, '0') + ':00');
                                that.MemberWithdrawTotalCount += that.SummaryArray[i].DC;
                            }
                            that.MemberWithdrawChartDate = that.format_date(that.SummaryArray[0].CD);
                        }
                    });
            },
            getMemberBonusHourlyData() {
                var that = this;
                that.MemberBonusChartData = [];
                that.MemberBonusChartLabel = [];
                that.MemberBonusTotalCount = 0;
                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CD = moment(this.selectedDateTS.startDate, "YYYYMMDD").format("YYYYMMDD")
                this.getDataApi(`/api/dc/lmbhs?p=&n=&s=CH&d=false&f[AGI]=${agi}&f[CD]=${CD}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.SummaryArray = d.D.Items;
                            that.MemberBonusChartData = [];
                            that.MemberBonusChartLabel = [];
                            that.MemberBonusTotalCount = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MemberBonusChartData.push(that.SummaryArray[i].BC);
                                that.MemberBonusChartLabel.push(that.SummaryArray[i].CH.toString().padStart(2, '0') + ':00');
                                that.MemberBonusTotalCount += that.SummaryArray[i].BC;

                            }
                            that.MemberBonusChartDate = that.format_date(that.SummaryArray[0].CD);
                        }
                    });
            },
            getMemberRegisterHourlyData() {
                var that = this;
                that.MemberRegisterChartData = [];
                that.MemberRegisterChartLabel = [];
                that.MemberRegisterTotalCount = 0;
                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CD = moment(this.selectedDateTS.startDate, "YYYYMMDD").format("YYYYMMDD");
                this.getDataApi(`/api/dc/lmrhs?p=&n=&s=CH&d=false&f[AGI]=${agi}&f[CD]=${CD}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.SummaryArray = d.D.Items;
                            that.MemberRegisterChartData = [];
                            that.MemberRegisterChartLabel = [];
                            that.MemberRegisterTotalCount = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MemberRegisterChartData.push(that.SummaryArray[i].RC);
                                that.MemberRegisterChartLabel.push(that.SummaryArray[i].CH.toString().padStart(2, '0') + ':00');
                                that.MemberRegisterTotalCount += that.SummaryArray[i].RC;
                            }
                            that.MemberRegisterChartDate = that.format_date(that.SummaryArray[0].CD);
                        }
                    });
            },
            format_date(value) {
                if (value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            },
            getMemberBonusDataByDateRange() {
                var that = this;
                that.MemberBonusChartData = [];
                that.MemberBonusChartLabel = [];
                that.MemberBonusTotalCount = 0;

                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CD_from = moment(String(this.selectedDateTS.startDate)).format('YYYYMMDD');
                var CD_to = moment(String(this.selectedDateTS.endDate)).format('YYYYMMDD');
                this.getDataApi(`/api/dc/lmbsbdr?p=&n=&s=CD&d=false&f[AGI]=${agi}&f[CD_from]=${CD_from}&f[CD_to]=${CD_to}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.SummaryArray = d.D.Items;
                            that.MemberBonusChartData = [];
                            that.MemberBonusChartLabel = [];
                            that.MemberBonusTotalCount = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MemberBonusChartData.push(that.SummaryArray[i].BC);
                                that.MemberBonusChartLabel.push(moment(String(that.SummaryArray[i].CD)).format('DD MMM'));
                                that.MemberBonusTotalCount += that.SummaryArray[i].BC;
                            }
                            that.MemberBonusChartDate = that.format_date(that.selectedDateTS.startDate) + " - " + that.format_date(that.selectedDateTS.endDate);
                        }
                    });
            },
            getMemberDepositDataByDateRange() {
                var that = this;
                that.MemberDepositChartData = [];
                that.MemberDepositChartLabel = [];
                that.MemberDepositTotalCount = 0;

                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CD_from = moment(String(this.selectedDateTS.startDate)).format('YYYYMMDD');
                var CD_to = moment(String(this.selectedDateTS.endDate)).format('YYYYMMDD');
                this.getDataApi(`/api/dc/lmtsbdr?p=&n=&s=CD&d=false&f[TT]=1&f[AGI]=${agi}&f[CD_from]=${CD_from}&f[CD_to]=${CD_to}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.SummaryArray = d.D.Items;
                            that.MemberDepositChartData = [];
                            that.MemberDepositChartLabel = [];
                            that.MemberDepositTotalCount = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MemberDepositChartData.push(that.SummaryArray[i].DC);
                                that.MemberDepositChartLabel.push(moment(String(that.SummaryArray[i].CD)).format('DD MMM'));
                                that.MemberDepositTotalCount += that.SummaryArray[i].DC;
                            }
                            that.MemberDepositChartDate = that.format_date(that.selectedDateTS.startDate) + " - " + that.format_date(that.selectedDateTS.endDate);
                        }
                    });
            },
            getMemberWithdrawDataByDateRange() {
                var that = this;
                that.MemberWithdrawChartData = [];
                that.MemberWithdrawChartLabel = [];
                that.MemberWithdrawTotalCount = 0;

                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CD_from = moment(String(this.selectedDateTS.startDate)).format('YYYYMMDD');
                var CD_to = moment(String(this.selectedDateTS.endDate)).format('YYYYMMDD');
                this.getDataApi(`/api/dc/lmtsbdr?p=&n=&s=CD&d=false&f[TT]=2&f[AGI]=${agi}&f[CD_from]=${CD_from}&f[CD_to]=${CD_to}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.SummaryArray = d.D.Items;
                            that.MemberWithdrawChartData = [];
                            that.MemberWithdrawChartLabel = [];
                            that.MemberWithdrawTotalCount = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MemberWithdrawChartData.push(that.SummaryArray[i].DC);
                                that.MemberWithdrawChartLabel.push(moment(String(that.SummaryArray[i].CD)).format('DD MMM'));
                                that.MemberWithdrawTotalCount += that.SummaryArray[i].DC;
                            }
                            that.MemberWithdrawChartDate = that.format_date(that.selectedDateTS.startDate) + " - " + that.format_date(that.selectedDateTS.endDate);
                        }
                    });
            },
            getMemberRegisterDataByDateRange() {
                var that = this;
                that.MemberRegisterChartData = [];
                that.MemberRegisterChartLabel = [];
                that.MemberRegisterTotalCount = 0;

                var agi = 0;

                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }

                var CD_from = moment(String(this.selectedDateTS.startDate)).format('YYYYMMDD');
                var CD_to = moment(String(this.selectedDateTS.endDate)).format('YYYYMMDD');
                this.getDataApi(`/api/dc/lmrsbdr?p=&n=&s=CD&d=false&f[AGI]=${agi}&f[CD_from]=${CD_from}&f[CD_to]=${CD_to}&f[CI]=${this.searchCurrency}`,
                    function (d, s) {
                        if (s) {
                            that.SummaryArray = d.D.Items;
                            that.MemberRegisterChartData = [];
                            that.MemberRegisterChartLabel = [];
                            that.MemberRegisterTotalCount = 0;
                            var arrL = parseInt(that.SummaryArray.length);
                            var i = 0;
                            for (i = 0; i < arrL; i++) {
                                that.MemberRegisterChartData.push(that.SummaryArray[i].RC);
                                that.MemberRegisterChartLabel.push(moment(String(that.SummaryArray[i].CD)).format('DD MMM'));
                                that.MemberRegisterTotalCount += that.SummaryArray[i].RC;
                            }
                            that.MemberRegisterChartDate = that.format_date(that.selectedDateTS.startDate) + " - " + that.format_date(that.selectedDateTS.endDate);
                        }
                    });
            },
            toggleFingPrintId(data, aRow, bRow) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.UBI;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(aRow + '_' + bRow);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[aRow + '_' + bRow] = d.D.Items;
                                that.opened.push(aRow + '_' + bRow)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.MI;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.I] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
            },
            renderActionType(int_status) {
                switch (int_status) {
                    case 2:
                        return 'Login';
                        break;
                    default:
                        return 'Register';
                        break;
                }
            },
            AutoUpdate() {
                this.nextUpdate();
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                //this.getMemberPromoTransList();
            },
            nextGetUpdate: function () {
                var CTCI = this.convertCurrency;
                var CC = this.getCurrencyCode;
                if (this.convertCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                    for (var i = 0; i < this.dd_currency1.length; i++) {
                        if (this.dd_currency1[i].label == CC) {
                            CTCI = this.dd_currency1[i].id;
                            break;
                        }
                    }
                    localStorage.setItem('CCUSD', CTCI);
                }
                else {
                    localStorage.setItem('CCUSD', this.convertCurrency);
                }
                this.SelectDate();
                this.getAgentGroup();
                this.getCurrencyList();
                //this.getMemberPromoTransList();
                this.AutoUpdate();
                this.setThousandCurrency(false);
                this.getDashboardRunningPromotion();
                this.getSANList();
                this.getBankList();
                this.getMemberOnlineMonitoring();
                this.getDashboardTotalMember();
                this.getDashboardPendingDeposit();
                this.isSENS = this.getUserInfo.ISENS;
                this.curAGI = this.getUserInfo.AGI;
            },
            setPreview(value) {
                this.previewUrl = value;
                this.bool_fullPreview = true;
            },
            randomNumber: function () {
                return Math.floor(Math.random() * (10 - 1 + 1)) + 1;
            },
            getDateInfo() {
                var that = this;

                this.DB_Month = moment().format('MMMM');
                this.DB_TDay = moment().endOf('month').format('DD');
                this.DB_CDay = moment().format('DD');
                this.DB_DProgress = ((this.DB_CDay * 100) / this.DB_TDay).toFixed(2);
                this.getDataApi(`/api/dc/drdt`,
                    function (d, s) {
                        if (s) {
                            that.DB_DRefresh = moment(d).format("MMM DD, YYYY hh:mm a");
                        }
                    });

                //var dateRange = [];
                //for (var i = 0; i < this.DB_TDay; i++) {
                //    dateRange.push(i + 1);
                //}
                //var temp = {
                //    categories: dateRange
                //}
                //Vue.set(this.chartOptions.xaxis, 0, temp)
                var dateRange = [];
                for (var i = 30; i >= 0; i--) {
                    var date = new Date();
                    date.setDate(date.getDate() - i);
                    dateRange.push(date.getDate().toString());
                }

                this.chartOptions = {
                    ...this.chartOptions, ...{
                        xaxis: {
                            categories: dateRange
                        }
                    }
                }
            },

            MemberOperationPage() {
                let routeData = this.$router.resolve({ path: '/DASH/MOL', query: { sa: this.searchAgent, sc: this.searchCurrency } });
                window.open(routeData.href, '_blank');
            },
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            next();
        },
        created() {
            this.$parent.showSubMenu = 'DASH';
            this.$parent.showActiveMenu = 'DASH.DBO';
            this.getAgentGroup();
            this.getCurrencyList();
            this.getMemberDepositHourlyData();
            this.getMemberWithdrawHourlyData();
            this.getMemberBonusHourlyData();
            this.getMemberRegisterHourlyData();
            //this.getMemberPromoTransList();
            this.AutoUpdate();
            this.setThousandCurrency(false);
            this.getDashboardRunningPromotion();
            this.getSANList();
            this.getBankList();
            this.getMemberOnlineMonitoring();
            this.getDashboardTotalMember();
            this.getDashboardPendingDeposit();
            this.getDateInfo();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.View_acce = this.checkModuleAccess('DBO', 'DASH', constAccessType.view);
            this.View_acce2 = this.checkModuleAccess('MOL', 'DASH', constAccessType.view);
        },
        mounted() {
            this.getConvertCurrencyList();
        },
        watch: {
            getLanguage() {
                //this.getMemberPromoTransList();
            },
            convertCurrency(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.alreadyLoad = false;
                }
            },
            searchCurrency(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.alreadyLoad = false;
                }
            }
        }
    }

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/DashboardOperation.vue